import React from 'react'

export default (props)=> 
    <svg {...props} width="512px" height="96px" viewBox="0 0 512 96" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Trustpilot_ratings_4halfstar-RGB">
            <g>
                <rect id="Rectangle-path" width="96" height="96" fill="#00B67A"/>
                <rect x="104" width="96" height="96" fill="#00B67A"/>
                <rect x="208" width="96" height="96" fill="#00B67A"/>
                <rect x="312" width="96" height="96" fill="#00B67A"/>
                <g id="Half" transform="translate(416.000000, 0.000000)">
                    <rect x="48" width="48" height="96" fill="#DCDCE6"/>
                    <rect class="st0" width="48" height="96" fill="#00B67A"/>
                </g>
                <path id="Shape" fill="#FFFFFF" d="M48,64.7L62.6,61l6.1,18.8L48,64.7z M81.6,40.4H55.9L48,16.2l-7.9,24.2H14.4l20.8,15l-7.9,24.2
                    l20.8-15l12.8-9.2L81.6,40.4L81.6,40.4L81.6,40.4L81.6,40.4z"/>
                <path fill="#FFFFFF" d="M152,64.7l14.6-3.7l6.1,18.8L152,64.7z M185.6,40.4h-25.7L152,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2
                    l20.8-15l12.8-9.2L185.6,40.4L185.6,40.4L185.6,40.4L185.6,40.4z"/>
                <path fill="#FFFFFF" d="M256,64.7l14.6-3.7l6.1,18.8L256,64.7z M289.6,40.4h-25.7L256,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2
                    l20.8-15l12.8-9.2L289.6,40.4L289.6,40.4L289.6,40.4L289.6,40.4z"/>
                <path fill="#FFFFFF" d="M360,64.7l14.6-3.7l6.1,18.8L360,64.7z M393.6,40.4h-25.7L360,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2
                    l20.8-15l12.8-9.2L393.6,40.4L393.6,40.4L393.6,40.4L393.6,40.4z"/>
                <path fill="#FFFFFF" d="M464,64.7l14.6-3.7l6.1,18.8L464,64.7z M497.6,40.4h-25.7L464,16.2l-7.9,24.2h-25.7l20.8,15l-7.9,24.2
                    l20.8-15l12.8-9.2L497.6,40.4L497.6,40.4L497.6,40.4L497.6,40.4z"/>
            </g>
        </g>
    </svg>